<template>
    <validated-field
            id="legaltexts-errors"
            :show-errors-on="showErrors" :has-any-errors="$v.toas.$invalid"
            :validation-rules="[{value: $v.toas.mandatoryAccepted, msg: $t('common.validation.legal.mandatory')}]">
        <div id="toas" class="field left aligned">
            <p id="legalIntroduction" class="legalIntro"
               v-html="requestedLegalTexts.consentIntroductionText"></p>
            <div class="ui list">
                <div class="item" v-for="(document) in requestedLegalTexts.documentList" :key="'legalTextItem-' + document.id">
                    <button type="button" class="ciam-legal-link-button" :id="'legalTextLink_' + document.id"
                            @click.prevent="onClick(document.id)"
                            @keypress.enter.prevent="onClick(document.id)" @ tabindex="0" v-text="document.title" >
                    </button>
                </div>
            </div>
            <div class="field" v-for="(checkbox, i) in requestedLegalTexts.checkboxes"
                 :key="'checkbox_' + i">
                <div class="ui checkbox">
                    <input
                            :aria-describedby="checkbox.consentRequired ? 'legaltexts-errors' : ''"
                            :aria-invalid="showErrors && checkbox.consentRequired ? 'true' : ''"
                            :aria-required="checkbox.consentRequired ? 'true' : ''"
                            type="checkbox" :id="'legaltext' + i" :name="'legaltext' + i"
                            v-model="acceptedLegalTexts[i]" @change="setAriaInvalid"
                            :class="optionalInputClass(checkbox.consentRequired)"/>
                    <legal-text-label :for-element="'legaltext' + i"
                                      :caption="checkbox.caption"
                                      :consent-required="checkbox.consentRequired"
                                      :texts="checkbox.texts" :on-click="onClick"></legal-text-label>
                </div>
            </div>
            <template v-for="legaltext in requestedLegalTexts.documentList">
                <legal-text-modal :id="legaltext.id" ref="modals" :key="'legalTextModal-' + legaltext.id" :country="country"></legal-text-modal>
            </template>
        </div>
    </validated-field>
</template>

<script>
import LegalTextLabel from './LegalTextLabel.vue'
import LegalTextModal from './LegalTextModal.vue'
import ValidatedField from '../ValidatedField.vue'

export default {
  components: {
    LegalTextLabel,
    LegalTextModal,
    ValidatedField
  },
  data: function () {
    return {
      // set checkboxes unchecked on init (true for checked)
      acceptedLegalTexts: Object.keys(this.requestedLegalTexts.checkboxes).map(() => false)
    }
  },
  validations () {
    return {
      toas: {
        mandatoryAccepted () {
          return this.areMandatoryBoxesChecked()
        }
      }
    }
  },
  props: {
    // Data for the requested legal texts (consists of introduction text, checkboxes and a document list)
    requestedLegalTexts: { type: Object, default: () => {} },
    // If errors should be visible or not
    showErrors: { type: Boolean, default: false },
    country: String
  },
  computed: {},
  methods: {
    onClick: function (legalTextId) {
      this.getModalBy(legalTextId).show()
    },
    setAriaInvalid: function (event) {
      if (event.target == null) {
        return
      }
      const isChecked = event.target.checked
      event.target.setAttribute('aria-invalid', !isChecked)
    },
    getModalBy: function (legalTextId) {
      return this.$refs.modals.find(x => x.id === legalTextId)
    },
    areMandatoryBoxesChecked: function () {
      for (let i = 0; i < this.requestedLegalTexts.checkboxes.length; i++) {
        if (this.requestedLegalTexts.checkboxes[i].consentRequired && !this.acceptedLegalTexts[i]) {
          return false
        }
      }
      return true
    },
    getAcceptedIds: function () {
      const notAcceptedLegalTextIds = []
      for (let i = 0; i < this.requestedLegalTexts.checkboxes.length; i++) {
        if (!this.acceptedLegalTexts[i]) {
          this.requestedLegalTexts.checkboxes[i].texts.forEach(function (text) {
            notAcceptedLegalTextIds.push(text.id)
          })
        }
      }
      const acceptedIds = this.requestedLegalTexts.documentList
        .map(legalText => legalText.id)
        .filter(legalText => !notAcceptedLegalTextIds.includes(legalText))
      console.debug('Accepted ids: ' + acceptedIds)
      return acceptedIds
    },
    optionalInputClass: function (consentRequired) {
      return consentRequired === false ? 'ciam-legal-text-input--optional' : ''
    }
  },
  watch: {
    $v: {
      handler (updatedValidation) {
        if (!updatedValidation.$invalid && this.showErrors) {
          this.$emit('accepted')
        }
      },
      deep: true
    }
  }
}
</script>

<style>
</style>
